export const MODIFY_FILE_PK_PRO_BLOCK = 'MODIFY_FILE_PK_PRO_BLOCK';

export function modifyFilePKProBlock(filePKProBlock){
    return{
        type: MODIFY_FILE_PK_PRO_BLOCK,
        mainState: {
            filePKProBlock: filePKProBlock
        }
    }
}